query GetSmsRequest($id: ID!) {
  smsRequest(id: $id) {
    id

    insertedAt
    updatedAt

    processedAt
    deliveredAt
    expiredAt
    scheduledAt

    multipartId

    hostNumber
    remoteNumber

    direction

    status
    errorCode

    message

    displayBody

    priority

    encoding

    smppCommandStatus
    smppNeedDeliveryReceipt
    smppPriority

    remoteNeedDeliveryReceipt

    multipartMethod
    udhCount
    udhSeqNum
    udhRefNum



    remoteMessagingEnabled
    remoteReferenceId
    remoteCountryCode
    remoteTier

    account {
      id
      name
    }
  }
}
